import {useRecoilValue} from "recoil";
import {AccessContextData} from "../../providers/access/AppContextProvider";
import * as React from "react";
import {useEffect} from "react";
import {useRequestPotentialStatusQuery} from "../../Queries";
import {Progress} from "../../components/Progress";

type RequestPotentialsDialogProps = {
   onComplete: () => void
}

export const PotentialsRequestDialog = ({onComplete}: RequestPotentialsDialogProps) => {
   const appContext = useRecoilValue(AccessContextData);
   const {data, stopPolling} = useRequestPotentialStatusQuery({
      variables: {
         tokens: appContext.requestPotentialTokens || []
      },
      fetchPolicy: "no-cache",
      pollInterval: 1000
   })

   useEffect(() => {
      if (data) {
         let allComplete = true;
         for (const integrationMessageElement of data?.IntegrationMessage || []) {
            if (!integrationMessageElement?.resultTs) {
               allComplete = false;
            }
         }
         if (allComplete) {
            stopPolling();
            onComplete();
         }
      }
   }, [data, onComplete, stopPolling])

   return <Progress/>
}